import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import iota from "../assets/images/New_Jul_2025/iota.svg";
import Plus from "../assets/images/Home/Plus.svg";

const PARTNER_CODE = "18990385";
const VENDOR_ID = "140";
const API_KEY = "SXai-6sxnvPBZ4vuHddTvFz20Kd3VEk-r1hcERMcM_c";

function SimStore() {
  const role = "Partner";

  const [plans, setPlans] = useState([]);
  const [plansLoading, setPlansLoading] = useState(true);
  const [plansError, setPlansError] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [planDetails, setPlanDetails] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [esn, setEsn] = useState("");
  const [zip, setZip] = useState("");
  const [activeTab, setActiveTab] = useState("Overview");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const res = await axios.post(
          `https://esimgo.clay.in/api/ESIM/Get_all_plans?flag=2&PartnerCode=${PARTNER_CODE}&vendor_id=${VENDOR_ID}`
        );
        if (res.data?.isSuccess && Array.isArray(res.data.getallplan)) {
          setPlans(res.data.getallplan);
        } else {
          setPlansError("Failed to load plans.");
        }
      } catch (err) {
        setPlansError(err.message || "Network error.");
      } finally {
        setPlansLoading(false);
      }
    };
    fetchPlans();
  }, []);

  const handleViewDetails = async (plan) => {
    setSelectedPlan(plan);
    setPlanDetails(null);
    setEsn("");
    setZip("");
    setShowModal(true);
    setDetailsLoading(true);
    setActiveTab("Overview");

    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(
        `https://esimgo.clay.in/api/ESIM/Get_plan_details_byid?plan_id=${plan.planid}&Partnercode=${PARTNER_CODE}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPlanDetails(res.data?.planlist?.[0] || null); // grab first plan from planlist
    } catch (err) {
      toast.error("Could not load plan details.");
    } finally {
      setDetailsLoading(false);
    }
  };

  const handleBuyNow = async () => {
    if (!esn.trim()) { toast.error("ESN/ICCID is required"); return; }
    if (!zip.trim()) { toast.error("Zip Code is required"); return; }

    setLoading(true);
    const payload = {
      request: {
        type: "Activate",
        esn,
        planId: selectedPlan?.planid ?? "02",
        language: "SPAN",
        zip,
        billingCode: "GIG175",
        e911Address: { street1: "123 Main St", street2: "JPEX Testing", city: "New York", state: "NY", zip },
      },
    };

    try {
      const response = await axios.post(
        "https://pwg.clay.in/api/external/ActivateEsnSim",
        payload,
        { headers: { accept: "*/*", "X-API-Key": API_KEY, "Content-Type": "application/json" } }
      );
      toast.success(`SIM Activated! MDN: ${response.data?.mdn || "N/A"}`);
      setShowModal(false);
      setSuccess(true);
    } catch (error) {
      toast.error(`Activation failed: ${error.response?.data?.data?.errors?.firstError?.message || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const inventoryCount = planDetails?.inventoryCount ?? planDetails?.InventoryCount ?? planDetails?.inventory_count;
  const isOutOfStock = inventoryCount !== undefined && inventoryCount !== null && Number(inventoryCount) === 0;
  const isBuyDisabled = !esn.trim() || !zip.trim() || loading || isOutOfStock;

  const flagUrl = (country) => `https://www.airhubapp.jp/assets/flags/${country?.trim().replace(/ /g, "_")}.svg`;

  return (
    <div className="p-4">
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Plans table */}
      {plansLoading ? (
        <div className="flex justify-center items-center py-16">
          <div className="animate-spin w-8 h-8 border-4 border-[#3E436D] border-t-transparent rounded-full" />
          <span className="ml-3 text-gray-500">Loading plans…</span>
        </div>
      ) : plansError ? (
        <div className="text-center py-12 text-red-500">{plansError}</div>
      ) : (
        <table className="w-full rounded-lg shadow-lg bg-white">
          <thead className="sticky top-0 bg-gray-200">
            <tr className="border-b">
              <th className="text-center p-3">Country/Region</th>
              <th className="text-center p-3">Data</th>
              <th className="text-center p-3">Validity</th>
              <th className="text-center p-3">Voice</th>
              <th className="text-center p-3">Plan Code</th>
              {role === "Partner" && <th className="text-center p-3">Price</th>}
              <th className="text-center p-3">Renewal</th>
              <th className="text-center p-3">Operator</th>
              <th className="text-center p-3">Add to Cart</th>
              <th className="text-center p-3">Details</th>
            </tr>
          </thead>
          <tbody>
            {plans.map((plan, idx) => (
              <tr key={plan.planid ?? idx} className="border-b hover:bg-gray-100">
                <td className="text-center p-2">
                  <div className="flex justify-start ml-8 items-center gap-2">
                    <img
                      src={flagUrl(plan.country)}
                      alt={plan.country}
                      className="w-8 h-8"
                      onError={(e) => { e.target.style.display = "none"; }}
                    />
                    <span>{plan.country}</span>
                  </div>
                </td>
                <td className="text-center p-2">{plan.data}</td>
                <td className="text-center p-2">{plan.validity}</td>
                <td className="text-center p-1">
                  <div className="flex items-center gap-x-2 relative">
                    <div className="flex-shrink-0">
                      <img src={Plus} alt="Plus" />
                    </div>
                    <div className="relative group flex-shrink-0">
                      <img src={iota} alt="iota" className="cursor-pointer" />
                      <div className="absolute bottom-full p-2 mb-2 hidden group-hover:block bg-[#3E436D] text-white text-xs z-10 whitespace-nowrap">
                        {plan.remarks}
                      </div>
                    </div>
                  </div>
                </td>
                <td className="text-center p-2 font-mono text-xs">{plan.plancode}</td>
                {role === "Partner" && (
                  <td className="text-center p-2">${plan.sellingcost}</td>
                )}
                <td className="text-center p-2">
                  {plan.recharge === "1" ? (
                    <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full font-medium">Auto</span>
                  ) : (
                    <span className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full font-medium">Manual</span>
                  )}
                </td>
                <td className="text-center p-2">{plan.operatorname}</td>
                <td className="text-center p-2">
                  <button className="rounded-2xl px-3 py-2 border-2 text-[#3E436D] hover:bg-[#3E436D] hover:text-white transition">
                    Add to cart
                  </button>
                </td>
                <td className="text-center p-2">
                  <button
                    onClick={() => handleViewDetails(plan)}
                    className="rounded-lg bg-[#3E436D] px-3 py-2 text-white text-sm hover:bg-[#2e3254] transition"
                  >
                    View Details
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Modal */}
      {showModal && selectedPlan && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white w-[700px] rounded-xl shadow-lg overflow-hidden max-h-[90vh] flex flex-col">
            {/* Header */}
            <div className="bg-[#3E436D] text-white p-4 relative text-center shrink-0">
              <button onClick={() => setShowModal(false)} className="absolute right-4 top-2 text-xl hover:opacity-70">✕</button>
              <h2 className="text-lg font-semibold">{selectedPlan.planname}</h2>
              <p className="text-sm opacity-80">{selectedPlan.connectivity} · {selectedPlan.plan_Class}</p>
              <div className="flex justify-around mt-4">
                <div className="bg-white/20 px-4 py-2 rounded">
                  <p className="font-bold">{selectedPlan.data}</p>
                  <p className="text-xs">Data</p>
                </div>
                <div className="bg-white/20 px-4 py-2 rounded">
                  <p className="font-bold">{selectedPlan.validity}</p>
                  <p className="text-xs">Validity</p>
                </div>
                <div className="bg-white/20 px-4 py-2 rounded">
                  <p className="font-bold">{selectedPlan.countries_covered && selectedPlan.countries_covered !== "NULL" ? selectedPlan.countries_covered : "1"}</p>
                  <p className="text-xs">Countries</p>
                </div>
                {isOutOfStock && (
                  <div className="bg-red-500/80 px-4 py-2 rounded">
                    <p className="font-bold text-white">⚠️ Out of Stock</p>
                  </div>
                )}
              </div>
            </div>

            {/* Tabs */}
            <div className="flex justify-around p-3 border-b text-sm shrink-0">
              {["Overview", "Features", "More Information"].map(tab => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`font-semibold px-3 py-1 rounded ${activeTab === tab ? "text-[#3E436D] border-b-2 border-[#3E436D]" : "text-gray-500"}`}
                >
                  {tab}
                </button>
              ))}
            </div>

            {/* Content */}
            <div className="p-4 overflow-y-auto flex-1 text-sm">
              {detailsLoading ? (
                <div className="flex justify-center items-center py-8">
                  <div className="animate-spin w-6 h-6 border-4 border-[#3E436D] border-t-transparent rounded-full" />
                  <span className="ml-2 text-gray-500 text-sm">Loading details…</span>
                </div>
              ) : activeTab === "Overview" ? (
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-gray-100 p-3 rounded">
                    <p className="font-semibold">Plan Coverage</p>
                    <p>{selectedPlan.connectivity}</p>
                  </div>
                  <div className="bg-gray-100 p-3 rounded">
                    <p className="font-semibold">Plan Type</p>
                    <p>{selectedPlan.plan_Class}</p>
                  </div>
                  <div className="bg-gray-100 p-3 rounded">
                    <p className="font-semibold">Network Configuration</p>
                    <p>Operator: {selectedPlan.operatorname}</p>
                    {planDetails?.apN_PIN && <p>APN: {planDetails.apN_PIN}</p>}
                    <p>Type: {selectedPlan.plan_Type?.replace(/_/g, " ")}</p>
                  </div>
                  <div className="bg-gray-100 p-3 rounded">
                    <p className="font-semibold">Plan Information</p>
                    <p>Plan Code: {selectedPlan.plancode}</p>
                    <p>Plan ID: {selectedPlan.planid}</p>
                    {planDetails && Object.entries(planDetails)
                      .filter(([k]) => !["apN_PIN","inventoryCount","InventoryCount","inventory_count","addinformation"].includes(k))
                      .slice(0, 3)
                      .map(([k, v]) => (
                        <p key={k} className="capitalize">{k.replace(/_/g, " ")}: {String(v)}</p>
                      ))
                    }
                  </div>
                </div>
              ) : activeTab === "Features" ? (
                <div className="grid grid-cols-1 gap-4">
                  <div className="bg-gray-100 p-3 rounded">
                    <p className="font-semibold">Remarks / Features</p>
                    <p>{selectedPlan.remarks}</p>
                  </div>
                </div>
              ) : (
                <div className="bg-gray-100 p-3 rounded" dangerouslySetInnerHTML={{ __html: planDetails?.addinformation || "No additional information." }} />
              )}
            </div>

            {/* Bottom Actions */}
            <div className="p-4 border-t shrink-0 flex flex-col items-center gap-3 w-full">
              <div className="flex gap-4 w-full">
                <input
                  className="border px-4 py-2 rounded-full flex-1 focus:outline-none focus:ring-2 focus:ring-[#3E436D]"
                  placeholder="ESN/ICCID"
                  value={esn}
                  onChange={(e) => setEsn(e.target.value)}
                  disabled={isOutOfStock}
                />
                <input
                  className="border px-4 py-2 rounded-full flex-1 focus:outline-none focus:ring-2 focus:ring-[#3E436D]"
                  placeholder="Enter Zip Code"
                  value={zip}
                  onChange={(e) => setZip(e.target.value)}
                  disabled={isOutOfStock}
                />
              </div>
              {/* <button
                onClick={handleBuyNow}
                disabled={isBuyDisabled}
                className={`px-6 py-2 rounded-full w-full text-white font-semibold transition
                  ${isOutOfStock
                    ? "bg-red-400 cursor-not-allowed"
                    : isBuyDisabled
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-[#3E436D] hover:bg-[#2e3254]"
                  }`}
              >
                {loading
                  ? "Processing…"
                  : isOutOfStock
                    ? "Out of Stock"
                    : `Buy Now — $${selectedPlan.sellingcost}`}
              </button> */}
            </div>
          </div>
        </div>
      )}

      {/* Success Modal */}
      {success && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg text-center shadow-lg w-[300px]">
            <h2 className="text-lg font-semibold mb-4">SIM purchased successfully 🎉</h2>
            <button
              onClick={() => { setSuccess(false); navigate("/SimMangement"); }}
              className="bg-[#3E436D] text-white px-6 py-2 rounded hover:bg-[#2e3254] transition"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default SimStore;